import * as React from 'react';
import {Link} from 'react-router-dom';
import {ButtonToolbar, CardGroup, Col, InputGroup, Row} from 'react-bootstrap';
import PulsoidClient from '../../../PulsoidClient';
import Form from 'react-bootstrap/Form';
import {getEditComponentByMetaWidgetId} from './EditMetaMapping';
import {PremiumWrapper} from '../../PremiumWrapper';
import {Action, Copy, Help} from '../../../system/buttons';
import {MenuItemContainer} from '../../../system/menu';
import {
  ResolvePredefinedWidgetFeatureDescription,
  ResolveWidgetLinkFeatureDescription,
} from '../../../system/FeatureDescriptionModal';
import {Loader} from '../../../system/Loader/Loader';
import {resolveWidget} from '../utils';
import Websocket from 'react-websocket';
import {
  PremiumComponentWrapper,
  SHOW_WHEN_NOT_PREMIUM,
} from '../../PremiumComponentWrapper';
import {PROD_HOST_NAME} from '../../../utils/locationUtils';
import {DASHBOARD_ROUTES} from '../../navigation/dashboard/DashboardRoutes';
import {buildRoute} from '../../navigation/navigationUtils';
import {
  MetaBpmAdvancedWidget,
  MetaBpmBasicWidget,
} from '@pulsoid-private/widgets-lib';
import {WidgetPreviewContainer} from '../../../system/WidgetPreviewContainer/WidgetPreviewContainer';
import {Recommendations} from './Recommendations';

export class EditContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {saving: false, predefinedWidgets: [], heartRate: 80};
    this.client = new PulsoidClient();
  }

  componentDidMount() {
    this.client.getWidget(this.props.match.params.id).then((widget) => {
      this.setState({...widget}, () => {
        this.client.getPredefinedWidgets().then((predefinedWidgets) => {
          this.setState({predefinedWidgets});
        });
      });
    });

    this.client.getUserInfo().then((profile) => {
      this.setState({profile: profile});
    });
  }

  handleOpen = (url) => () => {
    var params =
      'menubar=no,' +
      'location=no,' +
      'resizable=no,' +
      'scrollbars=no,' +
      'height=' +
      400 +
      ',' +
      'width=' +
      400;

    window.open(url, 'Heart rate widget', params);
  };

  handleSave = (configuration) => {
    this.setState({saving: true, updated: false}, () => {
      this.client
        .updateWidget(this.state.id, configuration)
        .then((_) => this.client.getWidget(this.state.id))
        .then((widget) => this.setState({...widget, saving: false}));
    });
  };

  handleUpdate = (configuration) => {
    this.setState({configuration, updated: true});
  };

  handleData = (pulse) => {
    let data = JSON.parse(pulse).data;
    this.setState({heartRate: data.heartRate});
  };

  profileMismatch = () => {
    return (
      this.state.profile &&
      this.state.profileId &&
      this.state.profileId !== this.state.profile.id
    );
  };

  render() {
    let widgetId;
    if (this.state.id) {
      widgetId = this.state.id;
    } else {
      widgetId = '';
    }

    const widgetWindowUrl = 'https://pulsoid.net/widget/view/' + widgetId;
    const widgetWindowFromLaunchUrl = widgetWindowUrl; //+ "?fromLaunch=true";

    const widgetWindowTestUrl = widgetWindowUrl + '?test=true';
    const widgetWindowTestFromLaunchUrl = widgetWindowTestUrl; //+ "&fromLaunch=true";
    const widgetComponent =
      this.state.configuration &&
      resolveWidget(
        this.state.configuration,
        this.state.metaId,
        1,
        this.state.heartRate,
        true
      );

    let links = (
      <>
        <div className="text-muted">
          Use the URL below in&nbsp;
          <a
            href="https://www.blog.pulsoid.net/post/how-to-add-browser-source-in-obs-streamlabs-obs-twitch-studio-xsplit"
            rel="noopener noreferrer"
            target="_blank"
          >
            OBS Studio, Streamlabs, Twitch Studio, XSplit
          </a>
          , or just launch it and use window capture.
        </div>
        <Form.Group as={Row} controlId="formPlaintextPassword">
          <Col sm="8">
            <InputGroup>
              <Form.Control readOnly value={widgetWindowUrl} />
              <InputGroup.Append>
                <InputGroup.Append>
                  <InputGroup.Text>
                    <ResolveWidgetLinkFeatureDescription
                      predefinedWidgetId={this.state.predefinedWidgetId}
                    />
                  </InputGroup.Text>
                </InputGroup.Append>
              </InputGroup.Append>
            </InputGroup>
            {/*<Form.Control readOnly value={widgetWindowUrl}/>*/}
          </Col>

          <Col>
            <ButtonToolbar>
              <div>
                <Copy text={widgetWindowFromLaunchUrl} />
              </div>
              <div style={{paddingLeft: '10px'}}>
                <Help onClick={this.handleOpen(widgetWindowFromLaunchUrl)}>
                  Launch
                </Help>
              </div>
              <div style={{paddingLeft: '10px'}}>
                <Help
                  variant={'secondary'}
                  onClick={this.handleOpen(widgetWindowTestFromLaunchUrl)}
                >
                  Demo
                </Help>
              </div>
            </ButtonToolbar>
          </Col>
        </Form.Group>
        <div className={'text-muted'}>
          Note: You can share this widget URL for collaborative streams to{' '}
          <a href="https://www.blog.pulsoid.net/post/how-to-add-two-heart-rate-widgets-to-a-stream">
            display multiple heart rates on screen
          </a>{' '}
          together.
        </div>
      </>
    );

    if (this.state.premium) {
      links = (
        <PremiumWrapper bi={{from: 'widget_edit', id: this.state.id}}>
          {links}
        </PremiumWrapper>
      );
    }

    if (this.state.profileId && this.state.profile) {
      if (this.state.profileId !== this.state.profile.id) {
        links = (
          <div>
            <div className="text-muted mb-3">
              This widget belongs to another account. You can copy it to your
              account to start using it.
            </div>
            <Action
              href={`/ui/configuration/${this.props.match.params.id}/clone`}
            >
              Copy widget to my account
            </Action>
          </div>
        );
      } else {
        links = (
          <Col sm={'8'}>
            {links}
            {this.state.metaId === MetaBpmAdvancedWidget && (
              <PremiumComponentWrapper mode={SHOW_WHEN_NOT_PREMIUM}>
                <Row className={'pt-5'}>
                  <Col>
                    A free Basic BPM widget is available in the Marketplace.{' '}
                    <br />
                    <a
                      href={
                        PROD_HOST_NAME +
                        '/ui/configuration/05930716-5345-48e9-886e-70039b030aea/add'
                      }
                      target={'_blank'}
                      rel="noreferrer"
                    >
                      Add & configure
                    </a>{' '}
                    now.
                  </Col>
                </Row>
              </PremiumComponentWrapper>
            )}
            {this.state.metaId === MetaBpmBasicWidget && (
              <Row className={'pt-5'}>
                <Col>
                  Do you want more options? Our Advanced BPM widget with ranges,
                  animations, more icons, and effects is available.
                  <br />
                  <a
                    href={
                      PROD_HOST_NAME +
                      '/ui/configuration/324a1d43-e3dd-49c6-9ebc-e973616754f4/add'
                    }
                    target={'_blank'}
                    rel="noreferrer"
                  >
                    Add & configure
                  </a>{' '}
                  now.
                </Col>
              </Row>
            )}
          </Col>
        );
      }
    }

    let refreshCacheNoteClassName = 'text-muted';
    if (this.state.updated) {
      refreshCacheNoteClassName = 'text-danger';
    }

    return (
      <MenuItemContainer title={'Widgets'}>
        {this.state.id && (
          <>
            <Row
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingLeft: '10px',
              }}
            >
              <h2>
                <Link to={buildRoute({path: DASHBOARD_ROUTES.CONFIGURATION})}>
                  Widgets{' '}
                </Link>
                {'> '}
                <>{this.state.note.name}</>
              </h2>
            </Row>
            <h5 style={{fontSize: '14px'}}>
              {this.state.note.description}&nbsp;
              <ResolvePredefinedWidgetFeatureDescription
                predefinedWidgetId={this.state.predefinedWidgetId}
              />
            </h5>
            <hr />

            <Websocket
              reconnectIntervalInMilliSeconds={3000}
              url={
                'wss://ramiel.pulsoid.net/listen/7f20184a-5fcf-11e6-8b77-86f30ca893d3'
              }
              onMessage={this.handleData}
            />

            <Row>
              <Col md={'auto'}>
                <WidgetPreviewContainer
                  id={this.state.metaId}
                  title="Widget Preview"
                >
                  {widgetComponent}
                </WidgetPreviewContainer>
              </Col>
              {links}
            </Row>
            {!this.state.saving && (
              <div style={{padding: '20px'}}>
                {getEditComponentByMetaWidgetId(this.state.metaId)({
                  onSave: (configuration) => {
                    if (this.profileMismatch()) {
                      alert(
                        "You can't save this widget. It belongs to another account."
                      );
                    } else {
                      this.handleSave(configuration);
                    }
                  },
                  onUpdate: (configuration) => this.handleUpdate(configuration),
                  configuration: this.state.configuration,
                  predefinedWidgetId: this.state.predefinedWidgetId,
                  premiumUpdate: this.state.premiumUpdate,
                  id: this.state.id,
                })}
              </div>
            )}
            {this.state.saving && (
              <Loader loading={true} description={'Saving new configuration'} />
            )}
            <div className={refreshCacheNoteClassName}>
              Note: To make changes live you might need to clear browser source
              cache in OBS
            </div>
          </>
        )}

        {!this.state.id && (
          <Loader loading={true} description={'Loading widget configuration'} />
        )}

        <Recommendations
          predefinedWidgets={this.state.predefinedWidgets}
          excludedMetaId={this.state.metaId}
        />
      </MenuItemContainer>
    );
  }
}
